var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "append-to-body": "",
        "custom-class": "dialog-body",
        "show-close": false,
        "close-on-click-modal": false,
        "press-escape": false,
        top: "10vh",
        width: "900px",
        height: "420px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ss-material-box-header",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_c("div", [_vm._v(_vm._s(_vm.title))])]
      ),
      _c("div", { style: { width: "900px", height: "420px" } }, [
        _c("div", { staticClass: "choose_resource" }, [
          _c(
            "div",
            { staticClass: "window-search" },
            [
              _c("span", { staticClass: "m-r-10" }, [_vm._v("上传到: ")]),
              _c("AppTreeSelect", {
                attrs: { data: _vm.treeSelectData },
                on: { change: (e) => (_vm.form.id = e) },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "window-list" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    accept: _vm.accept,
                    action: "#",
                    multiple: "",
                    "before-upload": _vm.beforeUpload,
                    "http-request": _vm.fileChange,
                    "show-file-list": false,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v(" 将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _c("div", { staticClass: "el-upload__text m-t-10" }, [
                    _vm._v(_vm._s(_vm.tips)),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "audioBox" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.uploadArr,
                        "empty-text": "无上传中文件",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "materialName",
                          label: "文件名",
                          width: "180",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  { attrs: { title: scope.row.file.name } },
                                  [_vm._v(_vm._s(scope.row.file.name))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "percent", label: "进度" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-progress", {
                                  attrs: { percentage: scope.row.authProgress },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "percent", label: "状态", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.statusText[scope.row.status])
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status === 0
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "red" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.del(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                                scope.row.status === 1
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#e6a23c" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.pauseUpload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("暂停")]
                                    )
                                  : _vm._e(),
                                scope.row.status === 3
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#e6a23c" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.resumeUpload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("恢复上传")]
                                    )
                                  : _vm._e(),
                                scope.row.status === 4
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#e6a23c" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.resumeUpload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重新上传")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm.awaitArr.length > 0
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.awaitArr, "show-header": false },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "materialName",
                              label: "文件名",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          attrs: { title: scope.row.file.name },
                                        },
                                        [_vm._v(_vm._s(scope.row.file.name))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1765288714
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "percent", label: "进度" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-progress", {
                                        attrs: {
                                          percentage: scope.row.authProgress,
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3311087229
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "percent",
                              label: "状态",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.statusText[scope.row.status]
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4073756157
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.status === 0 ||
                                      scope.row.status === 2
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "red" },
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.del(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                      scope.row.status === 1
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#e6a23c" },
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.pauseUpload(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("暂停")]
                                          )
                                        : _vm._e(),
                                      scope.row.status === 3
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#e6a23c" },
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.resumeUpload(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("恢复上传")]
                                          )
                                        : _vm._e(),
                                      scope.row.status === 4
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#e6a23c" },
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.resumeUpload(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("重新上传")]
                                          )
                                        : _vm._e(),
                                      scope.row.status === 9
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#e6a23c" },
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.aglinSureUp(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("重新添加")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2839500273
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "ss-material-box-bottom" },
        [
          _c("el-button", { on: { click: _vm.clearSuccess } }, [
            _vm._v("清除成功记录"),
          ]),
          _c("el-button", { on: { click: _vm.allAglinUp } }, [
            _vm._v("重新上传"),
          ]),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }